// Centralized site configuration & contact info.
// EDIT WHATSAPP_NUMBER with your real number (country code, no +, no spaces).
export const SITE = {
  brand: "XCARET MEXICO",
  domain: "XCTMEXICO.COM",
  whatsappNumber: "5219981071529",
  email: "direccion@xctmexico.com",
  phoneDisplay: "+52 (998) 107 1529",
};

export const DESTINATIONS = [
  {
    id: "hotel-xcaret-mexico",
    name: "Hotel Xcaret México",
    image:
      "https://images.unsplash.com/photo-1565358720137-55235e0878a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxjYW5jdW4lMjB0dXJxdW9pc2UlMjBvY2VhbiUyMGJlYWNofGVufDB8fHx8MTc4MTcyNjgxNHww&ixlib=rb-4.1.0&q=85",
    tag: { es: "All-Fun Inclusive", en: "All-Fun Inclusive" },
  },
  {
    id: "xcaret-arte",
    name: "Hotel Xcaret Arte",
    image:
      "https://images.unsplash.com/photo-1619732957399-f1718b89d474?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtZXhpY28lMjBqdW5nbGUlMjByZXNvcnQlMjBuYXR1cmV8ZW58MHx8fHwxNzgxNzI2ODE0fDA&ixlib=rb-4.1.0&q=85",
    tag: { es: "Adultos · Arte", en: "Adults · Art" },
  },
  {
    id: "casa-de-la-playa",
    name: "La Casa de la Playa",
    image:
      "https://images.unsplash.com/photo-1743697706311-120044ecaf22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjYW5jdW4lMjB0dXJxdW9pc2UlMjBvY2VhbiUyMGJlYWNofGVufDB8fHx8MTc4MTcyNjgxNHww&ixlib=rb-4.1.0&q=85",
    tag: { es: "Lujo · Boutique", en: "Luxury · Boutique" },
  },
  {
    id: "occidental-xcaret",
    name: "Occidental at Xcaret",
    image:
      "https://images.unsplash.com/photo-1773102722675-725dbe7ad75e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxtZXhpY28lMjBqdW5nbGUlMjByZXNvcnQlMjBuYXR1cmV8ZW58MHx8fHwxNzgxNzI2ODE0fDA&ixlib=rb-4.1.0&q=85",
    tag: { es: "Familiar", en: "Family" },
  },
  {
    id: "tulum",
    name: "Tulum",
    image:
      "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: { es: "Pueblo Mágico", en: "Magic Town" },
  },
  {
    id: "parques-xcaret",
    name: { es: "Parques Xcaret", en: "Xcaret Parks" },
    image:
      "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: { es: "Xel-Há · Xplor · Xoximilco", en: "Xel-Há · Xplor · Xoximilco" },
  },
];

export const ROUTES_PRICING = [
  { route: "Aeropuerto Cancún → Hotel Xcaret México", vehicle: { es: "Van Privada", en: "Private Van" }, price: "75" },
  { route: "Aeropuerto Cancún → Xcaret Arte", vehicle: { es: "Van Privada", en: "Private Van" }, price: "75" },
  { route: "Aeropuerto Cancún → La Casa de la Playa", vehicle: { es: "SUV Privada", en: "Private SUV" }, price: "85" },
  { route: "Aeropuerto Cancún → Playa del Carmen", vehicle: { es: "Van Privada", en: "Private Van" }, price: "65" },
  { route: "Aeropuerto Cancún → Tulum", vehicle: { es: "Van Privada", en: "Private Van" }, price: "120" },
  { route: { es: "Hotel Xcaret → Parques (ida y vuelta)", en: "Hotel Xcaret → Parks (round trip)" }, vehicle: { es: "Van Privada", en: "Private Van" }, price: "45" },
];

// Puntos de recogida / destinos en Cancún y Riviera Maya (para el buscador)
export const LOCATIONS = [
  "Aeropuerto Internacional de Cancún (CUN)",
  "Aeropuerto de Tulum (TQO)",
  "Zona Hotelera Cancún",
  "Centro de Cancún",
  "Puerto Juárez",
  "Isla Mujeres (Ferry Puerto Juárez)",
  "Puerto Morelos",
  "Playa del Carmen Centro",
  "Playacar",
  "Puerto Aventuras",
  "Akumal",
  "Bahía Príncipe",
  "Tulum Centro",
  "Tulum Zona Hotelera",
  "Cobá",
  "Valladolid",
  "Chichén Itzá",
  "Holbox (Chiquilá Ferry)",
  "Hotel Xcaret México",
  "Hotel Xcaret Arte",
  "La Casa de la Playa",
  "Occidental at Xcaret Destination",
  "Grand Palladium Riviera Maya",
  "TRS Yucatán / Coral",
  "Iberostar Paraíso / Selection",
  "Barceló Maya Grand Resort",
  "Bahía Príncipe Grand Coba / Tulum",
  "Riu Palace / Riu Playacar",
  "Secrets / Dreams Riviera Cancún",
  "Sandos Caracol / Playacar",
  "Vidanta Riviera Maya",
  "Mayakoba (Rosewood / Banyan Tree / Fairmont)",
  "Hard Rock Hotel Riviera Maya",
  "Palace Resorts (Moon / Sun / Beach Palace)",
  "Nickelodeon / Planet Hollywood",
  "Hotel Xcaret (Parques: Xel-Há, Xplor, Xoximilco)",
  "Otro hotel / destino",
];

// Clases de vehículo (flota) para el selector de reserva
export const VEHICLES = [
  { id: "economico", name: "Económico", capacity: "1-3", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/736fefd3237fd6eed75613262543dc6102d9547863c443e376ab89a7b5db19a2.jpeg" },
  { id: "confort", name: "Confort", capacity: "1-3", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/6511422c48e18c9994ac2adc35d3d21af8decf4f0b0401234a82d65e2902576b.jpeg" },
  { id: "business", name: "Business", capacity: "1-3", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/ba69f044a942d9234c283930fa55624e63f2542f6b5c135cb13abda015d9f6a0.jpeg" },
  { id: "premium", name: "Premium", capacity: "1-3", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/51ca9d2abd951a3226045f6381cf3990f00798db3f77d5dc4330dfed2eed16ea.jpeg" },
  { id: "vip", name: "VIP", capacity: "1-3", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/57634b2834b579ef58511676cc1d0a82819a41d494beb0108a5ebc4218b6ee33.jpeg" },
  { id: "suv", name: "SUV", capacity: "1-5", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/51c6e1a991a5ab87afcdb8bcd332894155361747ac85d3ba732873360df562f6.jpeg" },
  { id: "minivan", name: "Minivan", capacity: "1-7", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/1a2c28cbd4dd8952804e27cf2cb62f1cb54c03dc2aff215cef207aae757a5c89.jpeg" },
  { id: "minibus", name: "Minibús", capacity: "1-14", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/6ce9e7cbafd12f33730f0ff0762f059e6ec5e5ee58a224e1ca185c4f474f56da.jpeg" },
  { id: "autobus", name: "Autobús", capacity: "15-40", image: "https://static.prod-images.emergentagent.com/jobs/15da96d8-f7a7-49e8-a07b-9d1da525b1b3/images/aebe4d0a4e2869005f71e4f2a1c45893eade868c1d9c8d1c3d7f0ef8c4b76eb9.jpeg" },
];


